export default __webpack_public_path__ + "static/FTP-Fritzbox-7490de_06-cb3a590946289260e1e378f60af8f6eb.webp";